window.CalendarGrid = function () {
    var el = this;
    var template = $('#calendar-grid-template').html();
    var templateNumber = $('#calendar-number-template').html();
    var isMoving = false;
    var isRotating = false;
    var isResizing = false;
    var elsList = {};
    var copyItem = false;

    el.COUNT_DAYS = 7;
    el.MONDAY = 1;
    el.SATURDAY = 6;
    el.SUNDAY = 0;
    el.COUNT_ROWS = 6;
    el.HOLIDAYS = [el.SUNDAY, el.SATURDAY];

    el.currentMonth = new Date().getMonth() + 1;
    el.currentYear = new Date().getFullYear();

    if (el.currentMonth > 11) {
        el.currentMonth = 0;
        el.currentYear++;
    }

    el.data = {};
    el.monthsList = {};
    el.daysweekList = {};

    el.months = {};
    el.daysweek = {};

    el.selectedNumber = false;
    el.selectedGrid = false;
    el.numberScale = 1;

    el.init = function () {
        el.daysweek = el.daysweekList[el.language.current];
        el.months = el.monthsList[el.language.current];
    };

    function getTexts(data, iteration) {
        var numbers = data.days.numbers;
        var items = [];

        if (
            numbers.hasOwnProperty('items')
            && numbers.items.hasOwnProperty(iteration)
            && numbers.items[iteration].hasOwnProperty('texts')
        ) {
            for (var i in numbers.items[iteration].texts) {
                var item = $.extend(true, {}, numbers.items[iteration].texts[i]);

                item.rows = [];

                for (var j in numbers.items[iteration].texts[i].rows) {
                    item.rows.push(numbers.items[iteration].texts[i].rows[j]);
                }

                items.push(item);
            }
        }

        return items;
    }

    function getBackgrounds(data, iteration) {
        var numbers = data.days.numbers;
        var items = [];

        if (
            numbers.hasOwnProperty('items')
            && numbers.items.hasOwnProperty(iteration)
            && numbers.items[iteration].hasOwnProperty('backgrounds')
        ) {
            for (var i in numbers.items[iteration].backgrounds) {
                var item = $.extend(true, {}, numbers.items[iteration].backgrounds[i]);

                item.id = i;
                switch (item.type) {
                    case 'custom':
                        item.url = window.location.origin + el.projectsPath + '/' + window.bookSid + '/workimages/' + item.name;
                        break;
                    case 'template':
                        item.url = window.location.protocol + '//' + window.location.hostname + '/img/uploaded/souvenir/templates/' + item.theme_id + '/workimages/' + item.name;
                        break;
                }

                items.push(item);
            }
        }

        return items;
    }

    function getWeeks(data) {
        var i, item, fill;
        var items = [];
        var number = 0;
        var days = el.daysweek;
        var week = data.days.week;

        for (i in days) {
            item = days[i];
            fill = week.fill;

            if (el.HOLIDAYS.indexOf(item.id) !== -1) {
                fill = data.days.holidays.fill;
            }

            items.push({
                x: parseInt(data.days.width / el.COUNT_DAYS) * number,
                width: parseInt(data.days.width / el.COUNT_DAYS),
                name: item.short_name,
                size: week.size,
                family: week.family,
                fill: fill,
                border: week.border,
                height: week.height,
                text_x: week.text_x,
                text_y: week.text_y,
                alignment_baseline: week.alignment_baseline,
                text_anchor: week.text_anchor,
                background_fill: week.background_fill,
                background_opacity: week.background_opacity,
            });

            number++;
        }

        return items;
    }

    function getNumbers(data, year, month, necessaryNumber) {
        year = typeof year !== 'undefined' ? year : el.currentYear;
        month = typeof month !== 'undefined' ? month : el.currentMonth;

        var items = [];
        var firstDay = new Date(year, month, 1).getDay();
        var lastDay = new Date(year, month + 1, 0).getDay();
        var countDays = new Date(year, month + 1, 0).getDate();
        var previousDays = 0;
        var nextDays = 0;

        if (firstDay !== el.MONDAY && firstDay !== el.SUNDAY) {
            previousDays = firstDay - 1;
        }

        if (firstDay === el.SUNDAY) {
            previousDays += el.COUNT_DAYS - 1;
        }

        if (lastDay !== el.SUNDAY) {
            nextDays += el.COUNT_DAYS - lastDay;
        }

        var countRows = el.COUNT_ROWS;

        var item, row, day, column, currentDay, fill, iteration = 0, days = el.daysweek;
        for (row = 0, column = 0, currentDay = 1; row < countRows; row++, column = 0) {
            for (day in days) {
                fill = data.days.numbers.fill;

                if (countDays === 0) {
                    fill = data.days.ext_days.fill;
                }

                if (previousDays === 0 && countDays > 0) {
                    countDays--;
                }

                if (previousDays > 0) {
                    currentDay = -previousDays + 1;
                    previousDays--;
                    fill = data.days.ext_days.fill;
                }

                if (el.HOLIDAYS.indexOf(days[day].id) !== -1) {
                    fill = data.days.holidays.fill;
                }

                item = {
                    id: iteration,
                    x: parseInt(data.days.width / el.COUNT_DAYS) * column,
                    y: parseInt((data.days.height - data.days.week.height) / countRows) * row,
                    width: parseInt(data.days.width / el.COUNT_DAYS),
                    height: parseInt((data.days.height - data.days.week.height) / countRows),
                    name: new Date(year, month, currentDay).getDate(),
                    size: data.days.numbers.size,
                    family: data.days.numbers.family,
                    fill: fill,
                    border: data.days.numbers.border,
                    text_x: data.days.numbers.text_x,
                    text_y: data.days.numbers.text_y,
                    alignment_baseline: data.days.numbers.alignment_baseline,
                    text_anchor: data.days.numbers.text_anchor,
                    background_fill: data.days.numbers.background_fill,
                    background_opacity: data.days.numbers.background_opacity,
                    backgrounds: getBackgrounds(data, iteration),
                    texts: getTexts(data, iteration),
                };

                if (iteration === parseInt(necessaryNumber)) {
                    return item;
                }

                currentDay++;
                column++;
                iteration++;

                items.push(item);
            }
        }

        return items;
    }

    el.show = function () {
        var templateData = {
            grids: []
        };

        var i, item;
        for (i in el.data) {
            item = el.data[i];
            if (Object.keys(item.data).length !== 0) {
                templateData.grids.push({
                    svg: el.render(item.data),
                    id: item.id,
                    name: item.name,
                    mainwidth: item.data.width,
                    mainheight: item.data.height
                });
            }
        }

        el.dialog.show('calendar_grids', templateData);
    };

    el.showDate = function () {
        var templateData = {
            years: [],
            months: []
        };

        var i, item;
        for (i in el.months) {
            item = $.extend(true, {}, el.months[i]);
            item.active = parseInt(item.id) === el.currentMonth ? 'selected="selected"' : '';
            templateData.months.push(item);
        }

        var year = new Date().getFullYear();
        for (i = 0; i < 10; i++) {
            item = {
                id: year + i,
                name: year + i
            };

            item.active = item.id === el.currentYear ? 'selected="selected"' : '';
            templateData.years.push(item);
        }

        el.dialog.show('date', templateData);
    };

    el.initData = function (data, year, month) {
        year = typeof year !== 'undefined' ? year : el.currentYear;
        month = typeof month !== 'undefined' ? month : el.currentMonth;

        year = month > 11 ? year + parseInt(month / 12) : year;
        year = month < 0 ? year + parseInt(month / 12) - 1 : year;
        month = month > 11 ? month % 12 : month;

        if (month < 0) {
            month = month % 12 !== 0 ? 12 + month % 12 : 0;
        }

        var templateData = {
            opacity: data.opacity,
            fill: data.fill,
            year: {
                enabled: data.year.enabled,
                x: data.year.x,
                y: data.year.y,
                size: data.year.size,
                family: data.year.family,
                fill: data.year.fill,
                name: year
            },
            month: {
                enabled: data.month.enabled,
                x: data.month.x,
                y: data.month.y,
                size: data.month.size,
                family: data.month.family,
                fill: data.month.fill,
                name: el.months[month].name
            },
            days: {
                x: data.days.x,
                y: data.days.y,
                width: data.days.width,
                height: data.days.height,
                week_height: data.days.week.height,
                numbers_height: data.days.numbers.height,
                week: getWeeks(data),
                numbers: getNumbers(data, year, month)
            }
        };

        return templateData;
    };

    el.render = function (data, year, month, gridId, showRedactor) {
        var templateData = el.initData(data, year, month);
        templateData.grid_id = gridId;
        templateData.show_number_redactor = showRedactor || false;

        return el.templater.render(template, templateData);
    };

    el.add = function (id) {
        var format = el._parent.workData.workareas[el.selectWorkareaId].format;
        if (!format.hasOwnProperty('calendar_grids')) {
            format.calendar_grids = {};
        }

        var keys = Object.keys(format.calendar_grids);
        var number = 1;
        if (keys.length > 0) {
            number = parseInt(keys[keys.length - 1]) + 1;
        }

        var item = $.extend(true, {}, el.data[id].data);
        item.position = 1;
        item.mainwidth = item.width;
        item.mainheight = item.height;
        item.width = parseInt(format.width / 2);
        item.height = parseInt(item.width / (item.mainwidth / item.mainheight));
        item.x = parseInt((format.width - item.width) / 2);
        item.y = parseInt((format.height - item.height) / 2);
        item.rotate_angle = 0;
        item.rotate_x = 0;
        item.rotate_y = 0;

        format.calendar_grids[number] = item;
        el.workarea.render();
        el.preview.update();

        el.dialog.hide('calendar_grids');
        el.history.add();
    };

    el.set = function (option) {
        var item = el._parent.workData.workareas[el.selectWorkareaId].format.calendar_grids[el.selectId];

        item[option.property] = option.value;

        el.workarea.render();
        el.preview.update();
    };

    el.remove = function () {
        var element = el.svgRoot.getElementById('calendar-grid-' + el.selectWorkareaId + '-' + el.selectId);
        element.parentNode.removeChild(element);
        delete el._parent.workData.workareas[el.selectWorkareaId].format.calendar_grids[el.selectId];

        el.selection.hide();
        el.history.add();
    };

    /**
     *
     * @param {Event} event
     */
    el.beginMove = function (event) {
        event.preventDefault();
        isMoving = true;
        el._parent.isTransforming = true;
        var element = el.svgRoot.getElementById('calendar-grid-' + el.selectWorkareaId + '-' + el.selectId);

        elsList = {
            element: element,
            coord: el.transform.getPosition(element),
            selectElement: el.svgRoot.getElementById('calendar-grid-group-' + el.selectWorkareaId + '-' + el.selectId),
            lastX: 0,
            lastY: 0,
            x: 0,
            y: 0
        };
    };

    el.move = function (event) {
        if (isMoving) {
            var movementX = 0;
            var movementY = 0;

            if (event.originalEvent.touches !== undefined) {
                event.preventDefault();
                movementX = elsList.lastX === 0 ? 0 : event.originalEvent.touches[0].pageX - elsList.lastX;
                movementY = elsList.lastY === 0 ? 0 : event.originalEvent.touches[0].pageY - elsList.lastY;
                elsList.lastX = event.originalEvent.touches[0].pageX;
                elsList.lastY = event.originalEvent.touches[0].pageY;
            } else {
                movementX = elsList.lastX === 0 ? 0 : event.clientX - elsList.lastX;
                movementY = elsList.lastY === 0 ? 0 : event.clientY - elsList.lastY;
                elsList.lastX = event.clientX;
                elsList.lastY = event.clientY;
            }

            movementX /= el.workarea.workAreaScale;
            movementY /= el.workarea.workAreaScale;
            elsList.x += movementX;
            elsList.y += movementY;

            var reversal = el._parent.workData.workareas[el.selectWorkareaId].format;
            var element = elsList.element;
            var selectElement = elsList.selectElement;

            var pos = {
                x: parseInt(elsList.coord.x + elsList.x),
                y: parseInt(elsList.coord.y + elsList.y)
            };

            el.transform.setPosition(element, pos.x, pos.y);
            reversal.calendar_grids[el.selectId].x = pos.x;
            reversal.calendar_grids[el.selectId].y = pos.y;

            // detect transform for image
            var rotate = el.transform.getRotate(selectElement);
            reversal.calendar_grids[el.selectId].rotate_angle = rotate.angle;
            reversal.calendar_grids[el.selectId].rotate_x = rotate.x;
            reversal.calendar_grids[el.selectId].rotate_y = rotate.y;

            el.selection.update(selectElement);
        }
    };

    el.endMove = function () {
        if (isMoving) {
            isMoving = false;
            el.history.add();
        }
    };

    /**
     *
     * @param {Event} event
     */
    el.beginRotate = function (event) {
        event.preventDefault();
        isRotating = true;
        el._parent.isTransforming = true;

        var element = el.svgRoot.getElementById('calendar-grid-group-' + el.selectWorkareaId + '-' + el.selectId);
        var pos = el.transform.getPosition(el.svgRoot.getElementById('calendar-grid-' + el.selectWorkareaId + '-' + el.selectId));
        var innerPos = element.getBBox();

        elsList = {
            element: element,
            coords: {
                x: pos.x,
                y: pos.y,
                width: pos.width,
                height: pos.height,
                centerX: pos.x + pos.width / 2,
                centerY: pos.y + pos.height / 2,
                innerCenterX: innerPos.x + innerPos.width / 2,
                innerCenterY: innerPos.y + innerPos.height / 2
            }
        };
    };

    el.rotate = function (event) {
        if (isRotating) {
            var element = elsList.element;

            var pos = elsList.coords;

            var workAreaScale = el.workarea.workAreaScale;

            var offsetX = 0;
            var offsetY = 0;

            if (event.originalEvent.touches !== undefined) {
                event.preventDefault();
                var offsetPos = document.getElementById('backgrounds-rect-' + el.selectWorkareaId + '-1').getBoundingClientRect();
                offsetX = event.originalEvent.touches[0].clientX - offsetPos.left;
                offsetY = event.originalEvent.touches[0].clientY - offsetPos.top;
            } else {
                var offsetPos = document.getElementById('backgrounds-rect-' + el.selectWorkareaId + '-1').getBoundingClientRect();
                offsetX = event.clientX - offsetPos.left;
                offsetY = event.clientY - offsetPos.top;
            }

            var dx = pos.centerX * workAreaScale - offsetX;
            var dy = pos.centerY * workAreaScale - offsetY;
            var angle = Math.atan2(dy, dx) * 180 / Math.PI - 90;

            el.transform.setRotate(element, angle, elsList.coords.innerCenterX, elsList.coords.innerCenterY);

            var reversal = el._parent.workData.workareas[el.selectWorkareaId].format;
            var rotate = el.transform.getRotate(element);
            reversal.calendar_grids[el.selectId].rotate_angle = rotate.angle;
            reversal.calendar_grids[el.selectId].rotate_x = elsList.coords.innerCenterX;
            reversal.calendar_grids[el.selectId].rotate_y = elsList.coords.innerCenterY;

            el.selection.update(element);
        }
    };

    el.endRotate = function () {
        if (isRotating) {
            isRotating = false;
            el.history.add();
        }
    };

    function updateResizingData(coords) {
        var item = el._parent.workData.workareas[el.selectWorkareaId].format.calendar_grids[el.selectId];

        // update position for viewer
        elsList.element.setAttribute('x', parseInt(coords.x));
        elsList.element.setAttribute('y', parseInt(coords.y));
        elsList.element.setAttribute('width', parseInt(coords.width));
        elsList.element.setAttribute('height', parseInt(coords.height));

        // update position for el._parent.workData
        item.x = parseInt(coords.x);
        item.y = parseInt(coords.y);
        item.width = parseInt(coords.width);
        item.height = parseInt(coords.height);

        el.selection.update(elsList.selectElement);
    }

    /**
     *
     * @param {Event} event
     * @param {string} type
     */
    el.beginResize = function (event, type) {
        if (event) {
            event.preventDefault()
        }
        isResizing = true;
        el._parent.isTransforming = true;
        var item = el._parent.workData.workareas[el.selectWorkareaId].format.calendar_grids[el.selectId];
        var element = el.svgRoot.getElementById('calendar-grid-' + el.selectWorkareaId + '-' + el.selectId);

        elsList = {
            element: element,
            selectElement: el.svgRoot.getElementById('calendar-grid-group-' + el.selectWorkareaId + '-' + el.selectId),
            coords: el.transform.getPosition(element),
            lastX: 0,
            lastY: 0,
            type: type,
            ratio: item.mainwidth / item.mainheight,
            x: 0,
            y: 0
        };

        elsList.area = el.transform.getPosition(elsList.element);
    };

    el.resize = function (event) {
        if (isResizing) {
            var movementX = 0;
            var movementY = 0;

            if (event.originalEvent.touches !== undefined) {
                event.preventDefault();
                movementX = elsList.lastX === 0 ? 0 : event.originalEvent.touches[0].pageX - elsList.lastX;
                movementY = elsList.lastY === 0 ? 0 : event.originalEvent.touches[0].pageY - elsList.lastY;
                elsList.lastX = event.originalEvent.touches[0].pageX;
                elsList.lastY = event.originalEvent.touches[0].pageY;
            } else {
                movementX = elsList.lastX === 0 ? 0 : event.clientX - elsList.lastX;
                movementY = elsList.lastY === 0 ? 0 : event.clientY - elsList.lastY;
                elsList.lastX = event.clientX;
                elsList.lastY = event.clientY;
            }

            movementX /= el.workarea.workAreaScale;
            movementY /= el.workarea.workAreaScale;

            var previosArea = $.extend(true, {}, elsList.area);
            var x, y;
            switch (elsList.type) {
                case 'y':
                    y = movementY;
                    x = movementY * elsList.ratio;

                    elsList.x += x;
                    elsList.y += y;

                    elsList.area.y = parseInt(elsList.coords.y + elsList.y);
                    elsList.area.width = parseInt(elsList.coords.width - elsList.x);
                    elsList.area.height = parseInt(elsList.coords.height - elsList.y);
                    break;
                case 'width':
                    x = movementX;
                    y = movementX / elsList.ratio;

                    elsList.x += x;
                    elsList.y += y;

                    elsList.area.width = parseInt(elsList.coords.width + elsList.x);
                    elsList.area.height = parseInt(elsList.coords.height + elsList.y);
                    break;
                case 'height':
                    y = movementY;
                    x = movementY * elsList.ratio;

                    elsList.x += x;
                    elsList.y += y;

                    elsList.area.width = parseInt(elsList.coords.width + elsList.x);
                    elsList.area.height = parseInt(elsList.coords.height + elsList.y);
                    break;
                case 'x':
                    x = movementX;
                    y = movementX / elsList.ratio;

                    elsList.x += x;
                    elsList.y += y;

                    elsList.area.x = parseInt(elsList.coords.x + elsList.x);
                    elsList.area.width = parseInt(elsList.coords.width - elsList.x);
                    elsList.area.height = parseInt(elsList.coords.height - elsList.y);
                    break;
            }

            if (elsList.area.width < 10 || elsList.area.height < 10) {
                elsList.area = $.extend(true, {}, previosArea);
            }

            updateResizingData(elsList.area);
        }
    };

    el.resizeFromBalloon = function () {
        el.beginResize();

        var newCoords = {
            x: $('#coord-x').val(),
            y: $('#coord-y').val(),
            width: $('#coord-width').val(),
            height: $('#coord-height').val()
        };
        var coord = {};
        var cell = el._parent.workData.workareas[el.selectWorkareaId].format.calendar_grids[el.selectId];
        var item = elsList.element;

        var diff = {
            x: newCoords.x - cell.x,
            y: newCoords.y - cell.y,
            width: newCoords.width - cell.width,
            height: newCoords.height - cell.height
        };

        coord = el.transform.getPosition(item);
        coord.x += diff.x;
        coord.y += diff.y;


        if (diff.width !== 0 && diff.height === 0) {
            coord.width += diff.width;
            coord.height = parseInt(coord.width / elsList.ratio);
        }

        if (diff.width === 0 && diff.height !== 0) {
            coord.height += diff.height;
            coord.width = parseInt(coord.height * elsList.ratio);
        }

        updateResizingData(coord);

        el.endResize();
    };

    el.endResize = function () {
        if (isResizing) {
            isResizing = false;
            el.history.add();
        }
    };

    el.copy = function () {
        copyItem = el._parent.workData.workareas[el.selectWorkareaId].format.calendar_grids[el.selectId];
    };

    el.paste = function () {
        var grids = el._parent.workData.workareas[el.selectWorkareaId].format.calendar_grids;
        if (!grids.hasOwnProperty(el.selectId) && !copyItem) {
            el.dialog.show('message', { message: Yii.t('No grid found to copy') });
            return false;
        }

        copyItem = copyItem || grids[el.selectId];

        var format = el._parent.workData.workareas[el.selectWorkareaId].format;
        if (!format.hasOwnProperty('calendar_grids')) {
            format.calendar_grids = {};
        }

        var keys = Object.keys(format.calendar_grids);
        var number = 1;
        if (keys.length > 0) {
            number = parseInt(keys[keys.length - 1]) + 1;
        }

        format.calendar_grids[number] = $.extend(true, {}, copyItem);
        el.workarea.render();
        el.preview.update();

        el.history.add();
        copyItem = false;
    };

    el.showPanel = function () {
        $('.calendar-panel').removeClass('hide');
    };

    el.updateDate = function () {
        var workareas = el._parent.workData.workareas;

        var workareaId, grids, gridId, grid;
        var year, month;
        for (workareaId in workareas) {
            grids = workareas[workareaId].format.calendar_grids;

            for (gridId in grids) {
                grid = grids[gridId];

                year = el.currentYear;
                month = el.currentMonth + parseInt(grid.position) - 1;

                year = month > 11 ? year + parseInt(month / 12) : year;
                year = month < 0 ? year + parseInt(month / 12) - 1 : year;
                month = month > 11 ? month % 12 : month;

                if (month < 0) {
                    month = month % 12 !== 0 ? 12 + month % 12 : 0;
                }

                grid.year.name = year;
                grid.month.name = el.months[month].name;
                grid.month.number = month;
            }
        }

        el.upImages.init();
    };

    el.renderSelectedNumber = function (partial) {
        var templateData = el.getSelectedNumber();
        templateData.partial = partial;

        var html = el.templater.render(templateNumber, templateData);
        $('#number-wrapper').html(html);
        el.numberScale = $('#calendar-number').width() / templateData.width;
    };

    el.getSelectedNumber = function () {
        var workarea = el.workData.workareas[el.selectWorkareaId];
        var grid = workarea.format.calendar_grids[el.selectedGrid];

        return getNumbers(grid, grid.year.name, grid.month.number, el.selectedNumber);
    };

    el.getSelectedNumberResources = function () {
        var workarea = el._parent.workData.workareas[el.selectWorkareaId];
        var numbers = workarea.format.calendar_grids[el.selectedGrid].days.numbers;

        if (!numbers.hasOwnProperty('items')) {
            numbers.items = {};
        }

        if (!numbers.items.hasOwnProperty(el.selectedNumber)) {
            numbers.items[el.selectedNumber] = {
                backgrounds: {},
                texts: {}
            };
        }

        return numbers.items[el.selectedNumber];
    };

    $('.js-calendar-grid-show').on('click', function () {
        el.show();
    });

    $('.js-date-show').on('click', function () {
        el.showDate();
    });

    $(document).on('click', '.js-date-set', function () {
        el.currentYear = parseInt($('.js-date-year').val());
        el.currentMonth = parseInt($('.js-date-month').val());
        el.updateDate();
        el.workarea.render();
        el.preview.render();
    });

    $(document).on('click', '.js-calendar-grid-add', function () {
        el.add($(this).attr('data-id'));
    });

    $(document).on('click', '.js-calendar-grid-set', function () {
        el.set({
            property: $(this).attr('data-property'),
            value: $(this).val()
        });
    });

    $(document).on('change', '.js-calendar-grid-year', function () {
        el.currentYear = parseInt($(this).val());
        el.updateDate();
        el.workarea.render();
        el.preview.render();
    });

    $(document).on('change', '.js-calendar-grid-month', function () {
        el.currentMonth = parseInt($(this).val());
        el.updateDate();
        el.workarea.render();
        el.preview.render();
    });

    $('.js-coord-input').on('change', function () {
        if (el.selectType === 'calendar_grids') {
            el.resizeFromBalloon();
        }
    });

    $(document).on('click', '.js-show-calendar-number-redactor', function (e) {
        e.preventDefault();
        e.stopPropagation();
        el.selectedNumber = $(this).attr('data-id');
        el.selectedGrid = $(this).attr('data-grid-id');
        el.dialog.show('calendar');
    });

    $(document).on('shown.bs.modal', '#calendar-modal', function () {
        el.renderSelectedNumber();
    });

    $(document).on('hidden.bs.modal', '#calendar-modal', function () {
        el.workarea.render();
        el.preview.update();
    });
};
